import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class AdmissionService {

    constructor(private http: CustomHttpService) { }

    addAdmission(data : any): Observable<any> {
        return this.http.post(environment.addAdmission, data);
    }

    getAllAdmissionsWithCount(data : any): Observable<any> {
        return this.http.post(environment.getAllAdmissionsWithCount, data);
    }

    moveToAdmission(data : any): Observable<any> {
        return this.http.post(environment.moveToAdmission, data);
    }

    updateAdmission(data : any): Observable<any> {
        return this.http.post(environment.updateAdmission, data);
    }

    bulkUpdateAdmissions(data : any): Observable<any> {
        return this.http.post(environment.bulkUpdateAdmissions, data);
    }

    deleteAdmission(data : any): Observable<any> {
        return this.http.post(environment.deleteAdmission, data);
    }

    bulkDeleteAdmission(data : any): Observable<any> {
        return this.http.post(environment.bulkDeleteAdmission, data);
    }

}

